// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1ICOb","modalFooterButton":"ModalNotes_modalFooterButton__301xK"};